<template>
  <div v-bind:class="{ 'tla-btn--flex': makeModelBot }">
    <div v-if="makeModelBot">
      <button href="#" class="tla-btn make-model-button make-model-button__negative" @click.prevent="callFirstStep">
        <span>Start again</span>
      </button>
    </div>
    <div v-if="!makeModelBot" class="block--center">
      <div class="start-again">
        <p class="start-again__header"><strong>{{ this.resetHeaderLabel }}</strong></p>
        <p class="start-again__button">
          <strong>
            <a href="#" class="tabs__tab tabs__tab--active" @click.prevent="callFirstStep">
              {{ this.resetButtonLabel }}
            </a>
          </strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import {
  Validator
} from 'vee-validate';
import {
  Component,
  Prop,
  Vue,
  Inject
} from 'vue-property-decorator';
import {
  namespace
} from 'vuex-class';
import { loggingService } from '../../services/LoggingService';
import { scrollService } from '../../services/ScrollService';

const EnquiryModule = namespace('enquiryModule');
const VehicleModule = namespace('vehicleModule');

@Component
export default class StartAgainComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @EnquiryModule.Action public submitFormReset;

  @VehicleModule.Action public submitVehicleFormReset;

  @Prop({ default: 'Not happy with your selection?' })
  public resetHeaderLabel!: string;

  @Prop({ default: 'Start again' })
  public resetButtonLabel!: string;

  @Prop({ default: false })
  public makeModelBot!: boolean;

  public callFirstStep(): void {
    loggingService.recordEvent(
      'eventTracking',
      'formEvent',
      'Form Step Vehicle Details',
      'Next'
    );

    this.$events.$emit('formReset');
    this.$validator.pause();

    this.submitFormReset().then(() => {
      this.$nextTick(() => {
        this.$validator.errors.clear();
        this.$validator.fields.items.forEach((field) => field.reset());
        this.$validator.resume();
        scrollService.scrollToTop();
      });
    });
  }
}
</script>
